export default function Privacy({ dismissModal, isOpen }) {
  const handleDismiss = (event) => {
    dismissModal(event.currentTarget.id)
  }

  return (
    <div
      className={`portfolio-modal modal${isOpen ? ' is-open' : ''}`}
      id="privacy"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-content">
        <div className="close-modal" id="privacydismiss" onClick={handleDismiss}>
          <div className="lr">
            <div className="rl"></div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="modal-body">
                <h2>Privacy Policy</h2>
                <hr className="star-primary" />
                <div className="privacy-container">
                  <div className="row">
                    <div className="col-xs-12 col-md-5 col-lg-3">
                      <div className="privacy-image-container">
                        <img src="images/analytics.png" alt="" />
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-7 col-lg-9">
                      <div className="privacy-title">
                        <span>Statistics and data collection</span>
                        <br />
                      </div>
                      <div className="privacy-text">
                        <span>
                          Ahhmm... the thing is, we don't really collect any data or use any cookies other than the
                          ones used by the <span style={{ color: '#4285f4' }}>G</span>
                          <span style={{ color: '#ea4335' }}>o</span>
                          <span style={{ color: '#fbbc05' }}>o</span>
                          <span style={{ color: '#4285f4' }}>g</span>
                          <span style={{ color: '#34a853' }}>l</span>
                          <span style={{ color: '#ea4335' }}>e</span> Analytics API. Any data provided when contacting us is not stored in any database or shared with third-party companies. 
                          We don't like that. Prioritizing the safety of your personal data is a must! We were born on the internet, just like you, and we understand that it can be kind of 
                          creepy when all your data is floating around, accessible to anyone... and sometimes, it can even be dangerous.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="privacy-container">
                  <div className="row">
                    <div className="col-xs-12 col-md-5 col-lg-3">
                      <div className="privacy-image-container">
                        <img src="images/letter.png" alt="" />
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-7 col-lg-9">
                      <div className="privacy-title">
                        <span>Contact</span>
                        <br />
                      </div>
                      <div className="privacy-text">
                        <span>
                          We like to receive emails!! As long as they are not spam, of course. For any inquiry, you
                          can contact us:
                        </span>
                      </div>
                      <ul className="privacy-text" style={{ marginLeft: '20px', marginTop: '20px' }}>
                        <li>By email: info@mandrilsoft.com</li>
                        <li>
                          By filling the form located here:{' '}
                          <span style={{ color: '#c94c4c' }}>http://www.mandrilsoft.com/#/contact</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="privacy-container">
                  <div className="row">
                    <div className="col-xs-12 col-md-5 col-lg-3">
                      <div className="privacy-image-container">
                        <img src="images/stats.png" alt="" />
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-7 col-lg-9">
                      <div className="privacy-title">
                        <span>About Google Analytics</span>
                        <br />
                      </div>
                      <div className="privacy-text">
                        <span>
                        Google Analytics is a web analytics service provided by Google that tracks and reports website traffic. Google uses the data collected to 
                        track and monitor the use of our Service. This data may be shared with other Google services. Google may also use the collected data to 
                        contextualize and personalize the ads displayed through its advertising network. You can opt out of having your activity on the Service made 
                        available to Google Analytics by installing the Google Analytics Opt-out Browser Add-on. The add-on prevents the Google Analytics JavaScript 
                        (ga.js, analytics.js, and dc.js) from sharing information about your visits with Google Analytics. For more information about Google's privacy 
                        practices, please visit the
                          <a
                            style={{ color: '#c94c4c' }}
                            href="https://policies.google.com/privacy?hl=en"
                            target="_blank"
                          >
                            {' '}
                            Google Privacy & Terms web page
                          </a>
                          .
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
